import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ILoading {
	loading: boolean;
}

const initialState: ILoading = {
	loading: false,
};

export const loadingSlice = createSlice({
	name: "metamask",
	initialState,
	reducers: {
		updateLoading: (state, actions: PayloadAction<any>) => {
			state.loading = actions.payload;
		},
	},
});

export const { updateLoading } = loadingSlice.actions;

export default loadingSlice.reducer;
